export default "__VITE_ASSET__BSTMfl6e__"